// Pixel theme — every color token resolves to an entry in Endesga-32.
// The shape intentionally mirrors Claude Design's THEMES.pixel layout
// so adding another theme later (nebula/vellum) is a drop-in swap;
// only the values change.

import { E32 } from "./endesga32";

export interface Theme {
  name: string;
  // Palette
  bg: string;
  bgDeep: string;
  panel: string;
  panelSolid: string;
  panelEdge: string;
  panelEdgeStrong: string;
  ink: string;
  inkDim: string;
  inkFaint: string;
  accent: string;
  accentGlow: string;
  pageBg: string;
  // Fonts
  fontDisplay: string;
  fontBody: string;
  fontMono: string;
  // Structure
  radius: { panel: number; card: number; button: number; chip: number };
  glow: "none" | "ember";
  panelShape: "bitmap" | "soft" | "framed" | "riveted";
  divider: "dashed-pixel" | "hairline" | "forged";
  ornament: string;
  uppercase: boolean;
  letterSpacing: string;
}

export const pixelTheme: Theme = {
  name: "Pixel",
  bg: E32.parchment,
  bgDeep: E32.parchment,
  panel: E32.white,
  panelSolid: E32.white,
  panelEdge: E32.plum,
  panelEdgeStrong: E32.ink,
  ink: E32.ink,
  inkDim: E32.plum,
  inkFaint: E32.oxblood,
  accent: E32.ruby,
  // Endesga has no translucents; an "off" glow is just transparent.
  accentGlow: "rgba(162, 38, 51, 0)",
  pageBg: E32.parchment,
  fontDisplay: '"Press Start 2P", monospace',
  fontBody: '"VT323", "Press Start 2P", monospace',
  fontMono: '"Press Start 2P", monospace',
  radius: { panel: 0, card: 0, button: 0, chip: 0 },
  glow: "none",
  panelShape: "bitmap",
  divider: "dashed-pixel",
  ornament: "",
  uppercase: true,
  letterSpacing: "0.08em",
};
